module.exports = __webpack_public_path__ + "static/06-2-04ba93e1777324dd9e4fd85310232826.jpg";